module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073f4_banner_800x600.7f2e455e.png";